var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66683 4.99992C9.66683 6.58575 8.87582 7.98683 7.66683 8.83013V13.6666H5.94295L5.00014 12.7238L4.05733 13.6666H2.3335V8.83013C1.12451 7.98683 0.333496 6.58575 0.333496 4.99992C0.333496 2.42259 2.42283 0.333252 5.00016 0.333252C7.57749 0.333252 9.66683 2.42259 9.66683 4.99992ZM8.3335 4.99992C8.3335 6.84087 6.84111 8.33325 5.00016 8.33325C3.15921 8.33325 1.66683 6.84087 1.66683 4.99992C1.66683 3.15897 3.15921 1.66659 5.00016 1.66659C6.84111 1.66659 8.3335 3.15897 8.3335 4.99992ZM3.66683 12.1714L5.00014 10.8381L6.3335 12.1715V9.47333C5.91102 9.59907 5.46348 9.66659 5.00016 9.66659C4.53685 9.66659 4.0893 9.59907 3.66683 9.47333V12.1714Z",
    fill: "#11D000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinner);
export default __webpack_public_path__ + "static/media/winner.3fd1fcf299eeb7769d1bcd1cb673dc8f.svg";
export { ForwardRef as ReactComponent };